import { useState, useMemo } from "react";
import { Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import Accordionfn from "../../components/Accordion/Accordion";
import faq from "../../api/faq";
import businessFaq from "../../api/businessFaq";
import "./Faq.css";

function Faq() {
  const [tab, setTab] = useState("solo");
  const [query, setQuery] = useState("");

  const data = tab === "business" ? businessFaq : faq;

  const groups = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    const filtered = normalized
      ? data.filter(
          (q) =>
            q.question.toLowerCase().includes(normalized) ||
            q.answer.toLowerCase().includes(normalized)
        )
      : data;

    const map = {};
    filtered.forEach((q) => {
      const cat = q.category || "Other";
      (map[cat] = map[cat] || []).push(q);
    });
    return Object.entries(map);
  }, [data, query]);

  return (
    <div className="faqPage">
      <div className="faqHero">
        <div className="faqHeroInner">
          <div className="faqBadge">Need help? We've got you covered</div>
          <h1>
            {tab === "business"
              ? "SoloChat Business"
              : "Frequently Asked Questions"}
          </h1>
          <p>
            {tab === "business"
              ? "Everything businesses need to know about badges, storefronts, smart automation, and growing your brand on SoloChat."
              : "Welcome to the SoloChat FAQ! Find answers to common questions about messaging, rooms, Minutes, privacy, and more."}
          </p>

          <div className="faqTabs">
            <button
              className={tab === "solo" ? "active" : ""}
              onClick={() => setTab("solo")}
            >
              SoloChat
            </button>
            <button
              className={tab === "business" ? "active" : ""}
              onClick={() => setTab("business")}
            >
              SoloChat Business
            </button>
          </div>

          <div className="faqSearchWrap">
            <span className="faqSearchIcon">&#128269;</span>
            <input
              className="faqSearch"
              type="text"
              placeholder="Search questions..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="faqContent">
        {groups.length === 0 && (
          <div className="faqNoResults">
            <h3>No questions found</h3>
            <p>Try a different search term or switch tabs.</p>
          </div>
        )}

        {groups.map(([category, items]) => (
          <section key={category} className="faqSection">
            <div className="faqSectionTitle">
              <span className="faqSectionLine" />
              {category}
              <span className="faqCount">{items.length}</span>
            </div>
            <Accordion>
              {items.map((question) => (
                <Accordionfn
                  key={question.id}
                  id={`${tab}-${question.id}`}
                  header={question.question}
                  body={question.answer}
                />
              ))}
            </Accordion>
          </section>
        ))}

        <div className="faqFooter">
          <span>Still have questions?</span>
          <Link to="/contact">Contact our support team</Link>
        </div>
      </div>
    </div>
  );
}

export default Faq;
